export default "__VITE_ASSET__xBsG_Nlu__"